import {Component, inject, OnInit} from '@angular/core';
import {FooterComponent} from "../../../common/footer/footer.component";
import {FormControl, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {HeaderComponent} from "../../../common/header/header.component";

import {LocaleService} from "../../../../locale/locale.service";
import {ClaimType} from "../../../../enums/claim-type";
import {ClaimsService} from "../../../../services/claims.service";
import {FormNavigationService} from "../../../../services/form-navigation/form-navigation.service";
import { NavigationKey } from '../../../../enums/navigation-key-type';

@Component({
  selector: 'app-damage-type',
  imports: [
    FooterComponent,
    FormsModule,
    HeaderComponent,
    ReactiveFormsModule
  ],
  templateUrl: './damage-type.component.html',
  styleUrl: './damage-type.component.css'
})
export class DamageTypeComponent implements OnInit {
  locale = inject(LocaleService);
  private formNavigationService = inject(FormNavigationService);
  private claimService = inject(ClaimsService);

  showError: boolean = false;
  options: { headline: string, caption: string, value: string }[] = [];
  radioControl = new FormControl();

  ngOnInit(): void {
    this.options = [
      {
        headline: this.locale.currentTranslation.damageTypeOptionHeadline1,
        caption: this.claimService.isDriver() ? this.locale.currentTranslation.damageTypeOptionCaption1 : this.locale.currentTranslation.thirdPartyDamageTypeOptionCaption1,
        value: ClaimType.BodilyInjured
      },
      {
        headline: this.locale.currentTranslation.damageTypeOptionHeadline2,
        caption: this.claimService.isDriver() ? this.locale.currentTranslation.damageTypeOptionCaption2 : this.locale.currentTranslation.thirdPartyDamageTypeOptionCaption2,
        value: ClaimType.PropertyDamage
      },
      {
        headline: this.locale.currentTranslation.damageTypeOptionHeadline3,
        caption: this.claimService.isDriver() ? this.locale.currentTranslation.damageTypeOptionCaption3 : this.locale.currentTranslation.thirdPartyDamageTypeOptionCaption3,
        value: ClaimType.Both
      },
    ]
    this.claimService.getData().subscribe(() => {
      if (this.claimService?.claimReport()?.claimType) {
        this.radioControl = new FormControl(this.claimService.claimReport().claimType);
      }
    })
  }

  nextClicked() {
    this.evaluateShowError()
    if (!this.showError) {
      this.claimService.updateClaimReport({claimType: this.radioControl.getRawValue()});
      this.claimService.save().subscribe(() => {
        this.formNavigationService.navigate(NavigationKey['damage-type']);
      });
    }
  }

  private evaluateShowError() {
    let rawValue = this.radioControl.getRawValue();
    this.showError = rawValue == null;
  }

  setOption(value: string) {
    this.radioControl.patchValue(value);
    this.showError = false
  }
}
